var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(-0.163)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    transform: "translate(0.163 0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 18.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-instagram",
    "data-name": "Icon awesome-instagram",
    d: "M7.679,5.98a3.939,3.939,0,1,0,3.939,3.939A3.932,3.932,0,0,0,7.679,5.98Zm0,6.5A2.561,2.561,0,1,1,10.24,9.919a2.565,2.565,0,0,1-2.561,2.561ZM12.7,5.819a.919.919,0,1,1-.919-.919A.917.917,0,0,1,12.7,5.819Zm2.609.932a4.546,4.546,0,0,0-1.241-3.219,4.576,4.576,0,0,0-3.219-1.241c-1.268-.072-5.07-.072-6.338,0A4.569,4.569,0,0,0,1.29,3.529,4.561,4.561,0,0,0,.049,6.748c-.072,1.268-.072,5.07,0,6.338A4.546,4.546,0,0,0,1.29,16.3a4.582,4.582,0,0,0,3.219,1.241c1.268.072,5.07.072,6.338,0A4.546,4.546,0,0,0,14.065,16.3a4.576,4.576,0,0,0,1.241-3.219c.072-1.268.072-5.066,0-6.335Zm-1.638,7.7a2.592,2.592,0,0,1-1.46,1.46,16.93,16.93,0,0,1-4.528.309,17.062,17.062,0,0,1-4.528-.309,2.592,2.592,0,0,1-1.46-1.46,16.93,16.93,0,0,1-.309-4.528A17.062,17.062,0,0,1,1.691,5.39a2.592,2.592,0,0,1,1.46-1.46,16.93,16.93,0,0,1,4.528-.309,17.062,17.062,0,0,1,4.528.309,2.592,2.592,0,0,1,1.46,1.46,16.93,16.93,0,0,1,.309,4.528A16.92,16.92,0,0,1,13.667,14.447Z",
    transform: "translate(11.177 8.936)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.3ff1bee71138e90795f66c10de75de1f.svg";
export { ForwardRef as ReactComponent };